import React from 'react';
import './TargetLanding.css';
import image2 from "../../assets/wireframetarget.png";
import image1 from "../../assets/maintarget.png";
import Contact from '../contact/Contact'; // ✅ adjust path as needed

const TargetLanding = () => {
  return (
    <main className="target-landing section">
      <div className="container">
        <h1 className="section__title">Target App Landing Page</h1>

        <div className='target-image-container'>
          <img className="target-image" src={image1} alt="Target App Main Screen" />
        </div>

        <h2>Excited to share the landing page design for my latest app, Target! 🎯</h2>
        <p>Designed with a clean, modern aesthetic in <strong>Figma</strong>, the landing page focuses on a seamless user experience, guiding users through the app's features with clarity and ease.</p>

        <h3>Key Highlights:</h3>
        <ul className="target-features">
          <li>Sleek, minimalist design for a premium feel</li>
          <li>Responsive layout for smooth browsing on all devices</li>
          <li>Easy-to-navigate sections highlighting features and benefits</li>
          <li>Consistent branding to reflect the app's identity</li>
        </ul>

        <p>The app is now live on the Play Store! Check it out by visiting the link in my profile. 🌟</p>

        <div className='target-image-container'>
          <img className="target-image" src={image2} alt="Target App Wireframe" />
        </div>

        <p>This wireframe was designed in <strong>Figma</strong> to lay the groundwork for a clean, user-friendly interface.</p>

        <h3>Wireframe Highlights:</h3>
        <ul className="target-features">
          <li>Clear layout and hierarchy for seamless navigation</li>
          <li>Simple and structured design elements to enhance user interaction</li>
          <li>A blueprint for the final UI design, focusing on key sections</li>
        </ul>

        <div className="target-tools">
          <h4>Tools Used:</h4>
          <p>Figma for wireframing and UI design</p>
        </div>

        <section className="target-cta">
          <h2>Hire Me to Elevate Your Brand</h2>
          <p>
            If you're looking to transform your website and create designs that leave a lasting impression, I'm here to deliver exceptional results.
          </p>
        </section>

        {/* ✅ Contact Form Directly Rendered Below */}
        <div style={{ marginTop: '40px' }}>
          <Contact />
        </div>
      </div>
    </main>
  );
};

export default TargetLanding;
